import React from "react";
import { Link } from "react-router-dom";
import "./description.css";

const Description = () => (
    <section className="site-description-container description-entrance">
        <div className="site-description-content">
            <span className="site-description-badge">Modern real estate web experiences</span>
            <h1 className="site-description-title">Apto Websites</h1>
            <p className="site-description-text">
                Grow your real estate business with a modern, mobile-friendly website. Apto Websites delivers beautiful, customizable designs, IDX integration,
                and powerful marketing tools, all in one affordable package. Whether you’re an agent, team, or brokerage, we make it easy to stand out,
                attract leads, and grow your brand online.
            </p>
            <div className="site-description-actions">
                <Link className="cta primary" to="/templates">View templates</Link>
                <Link className="cta ghost" to="/pricing">See pricing</Link>
            </div>
        </div>
    </section>
);

export default Description;
